import React from "react";
import OperationsFullTable from "../../components/operations/OperationsFullTable";
import { connect } from "react-redux";
import { getOperationsByStatus } from "../../stores/actions/operationActions";

class Approved extends React.Component {
  state = {
    operations: []
  };

  componentDidMount() {
    this.props.getOperationsByStatus(2);
  }

  render() {
    const { operations } = this.props;
    return (
      <div>
        <OperationsFullTable
          title="Pendientes de firma"
          operations={operations}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    operations: state.operation.operations
  };
};

export default connect(
  mapStateToProps,
  { getOperationsByStatus }
)(Approved);
